import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../../supabaseClient';
import { Lock, AlertTriangle, ChevronLeft } from '../../components/Icons';
import logo from '../../assets/logo.png';
import styles from './AdminLogin.module.css';

function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { data, error: authError } = await supabase.auth.signInWithPassword({ email, password });
    if (authError) { setError(authError.message); setLoading(false); return; }

    // Cek apakah user ini admin
    const { data: adminData } = await supabase
      .from('admins').select('*').eq('user_id', data.user.id).single();

    if (!adminData) {
      await supabase.auth.signOut();
      setError('Akun ini tidak memiliki akses admin.');
      setLoading(false);
      return;
    }

    navigate('/admin/dashboard');
    setLoading(false);
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logoRow}>
          <img src={logo} alt="NOWGUT" className={styles.logoImg} />
          <div>
            <div className={styles.logoName}>NOWGUT</div>
            <div className={styles.logoTagline}>Admin Panel</div>
          </div>
        </div>

        <div className={styles.welcomeBox}>
          <div className={styles.welcomeIcon}>
            <Lock size={26} aria-hidden="true" />
          </div>
          <h1 className={styles.title}>Admin Login</h1>
          <p className={styles.subtitle}>Akses terbatas untuk tim NOWGUT</p>
        </div>

        {error && (
          <div className={styles.error}>
            <AlertTriangle size={18} aria-hidden="true" />{error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className={styles.field}>
            <label className={styles.label}>Email Admin</label>
            <input className={styles.input} type="email" value={email}
              onChange={e => setEmail(e.target.value)} placeholder="admin@nowgut.com" required />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Password</label>
            <input className={styles.input} type="password" value={password}
              onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          <button type="submit" className={styles.btn} disabled={loading}>
            {loading ? 'Memverifikasi...' : <><Lock size={16} aria-hidden="true" /> Masuk sebagai Admin</>}
          </button>
        </form>

        <p className={styles.backLink}>
          <Link to="/landing" className={styles.link}>← Kembali ke beranda</Link>
        </p>
      </div>
    </div>
  );
}

export default AdminLogin;